// extracted by mini-css-extract-plugin
export default {"title":"CasesByUserType_title__RKRIR","selector":"CasesByUserType_selector__XuwcV","activeSelector":"CasesByUserType_activeSelector__ipKCA"};